export enum PLATFORM_TYPE {
  ANDROID = 'Mozilla/5.0',
  IOS = 'AppleWebKit',
}
